export * from './app-footer.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-footer/index.ts